export default {"src":"/_next/static/media/403_marcos.f92cf1da.svg","height":241,"width":303};